import * as React from 'react';

import { ScrollContainer } from '../../ScrollContainer';

export const useScrollRef = (): {
  scrollRef: React.RefObject<ScrollContainer | null>;
  scrollToBottom: (isButtonClickScroll?: boolean) => void;
  onScrollHeightChange: () => void;
} => {
  const scrollRef = React.useRef<ScrollContainer | null>(null);

  const scrollToBottom = React.useCallback(
    (isButtonClickScroll?: boolean) => {
      if (scrollRef.current) {
        scrollRef.current.scrollToBottom(isButtonClickScroll);
      }
    },
    [scrollRef],
  );

  const onScrollHeightChange = React.useCallback(() => {
    if (scrollRef.current) {
      const isScrolledToBottom = scrollRef.current.isScrolledToBottom || false;

      setTimeout(() => {
        if (isScrolledToBottom) {
          if (scrollRef.current) {
            scrollRef.current.scrollToBottom();
          }
        }
      }, 0);
    }
  }, []);

  return { scrollRef, scrollToBottom, onScrollHeightChange };
};
